import * as React from 'react'
import {
    Alert,
    Button,
    Checkbox,
    Col,
    Divider,
    Form,
    Icon,
    Input,
    InputNumber,
    Modal,
    notification,
    Row,
    Select,
    Spin
} from 'antd';
import {FormComponentProps} from 'antd/lib/form';
import {withTranslation, WithTranslation} from 'react-i18next';
import {NewEmployeeItem, NewEmployeeStore} from 'src/stores/employees-store';
import {connect} from 'redux-scaffolding-ts'
import {nameof} from 'src/core/utils/object';
import autobind from 'autobind-decorator';
import {GetFieldDecoratorOptions} from 'antd/lib/form/Form';
import {formatMessage} from 'src/core/services/http.service';
import EmployeeEditor from 'src/components/employee-editor';
import RestrictionPlanEditor from 'src/components/restriction-plans-editor';
import {IdentityProps, withIdentity} from 'src/core/services/authentication';
import EditableTooltip from 'src/components/editable-tooltip/tooltip';
import LabelIcon from '../../../../components/editable-tooltip/label-icon';
import NewRestrictionPlanView from '../../restriction-plan/restriction-plan-new';
import {UserProfileProps, userHasRole} from "../../../../components/user-profile";

let FormItem = Form.Item;

interface NewEmployeeViewProps extends UserProfileProps {
    companyId: string,
    currency: string,
    onClose: (id: string | undefined, item?: NewEmployeeItem) => void;
    allowCir: boolean;
    allowCii: boolean;
}

interface NewEmployeeFormState {
    firstEntry: boolean,
    confirm: boolean,
    selectedTeamReport: boolean,
    selectedEmployeeReminder: boolean,
}

interface NewEmployeeViewState {
    restrictionPlanId: string | null,
    showRestrictionPlanCreationModal: boolean,
    showSetManagerModal: boolean,

}

interface ClassFormBodyProps extends WithTranslation, UserProfileProps {
    companyId: string,
    currency: string,
    item: NewEmployeeItem | undefined,
    onSave?: () => Promise<any>;
    setFieldsValue: any;
    getFieldDecorator<T extends Object = {}>(id: keyof T, options?: GetFieldDecoratorOptions): (node: React.ReactNode) => React.ReactNode;
    openRestrictionPlanAddModal?: () => void;
    allowCir: boolean;
    allowCii: boolean;
}

export class EmployeeFormBody extends React.Component<ClassFormBodyProps, NewEmployeeFormState> {
    constructor(props: ClassFormBodyProps) {
        super(props);
        let item = this.props.item || {} as NewEmployeeItem;
        this.state = {
            firstEntry: true,
            confirm: true,
            selectedTeamReport: item?.teamReport > 0 || false,
            selectedEmployeeReminder: item?.timesheetReminder > 0 || false
        }
    }
    @autobind
    private teamReportOnchange(e: any) {
        this.setState({ selectedTeamReport: !this.state.selectedTeamReport })
    }

    @autobind
    private employeeReminderOnchange(e: any) {
        this.setState({ selectedEmployeeReminder: !this.state.selectedEmployeeReminder })
    }

    @autobind
    private handleFocus(event: any) {
        event.target.select();
    }
    render() {
        const { t } = this.props;
        const { Option } = Select;

        var item = this.props.item || {} as NewEmployeeItem;

        if (this.state.firstEntry) {
            this.setState({ firstEntry: false });
        }

        return <Form id="modaForm" onKeyUp={(e) => { if (e.keyCode === 13 && this.props.onSave) { this.props.onSave(); } }} onSubmit={() => { if (this.props.onSave) { this.props.onSave(); } }}>

            <Row gutter={24} align='middle' justify='center' >
                <Col span={8}>
                    <h5 style={{ fontWeight: 'bold', marginTop: '7px' }}>{t("Identification")}</h5>
                </Col>
            </Row>
            <Row gutter={24} align='middle' justify='center' >              
            <Col span={12} >
              <Row gutter={24}>
                <Col span={24} >
                    <FormItem label={t("First Name")}>
                      {this.props.getFieldDecorator(nameof<NewEmployeeItem>('name'), {
                        initialValue: item.name,
                        rules: [],
                      })(
                        <Input placeholder={t('First Name')} type="text" />
                      )}
                    </FormItem>
                </Col>
              </Row>
              <EditableTooltip name="new-employee-identity" noIcon offset={4}>
                    <FormItem label={(
                        <LabelIcon>
                            {t("Identity (Email)")}
                        </LabelIcon>
                    )}>
                        {this.props.getFieldDecorator(nameof<NewEmployeeItem>('identityName'), {
                            initialValue: item.identityName,
                            rules: [{ required: true, message: t('Identity required') }],
                        })(
                            <Input placeholder={t('user@domain.com')} type="text" />
                        )}
                        </FormItem></EditableTooltip>
                    <Row gutter={24}>
                        <Col span={24} >
                            <EditableTooltip name="new-employee-function" noIcon>
                                <FormItem label={(
                                    <LabelIcon>
                                        {t("Function")}
                                    </LabelIcon>
                                )}>
                                    {this.props.getFieldDecorator(nameof<NewEmployeeItem>('function'), {
                                        initialValue: item.function,
                                        rules: [],
                                    })(
                                        <Input placeholder={t('Function')} type="text" />
                                    )}
                                </FormItem>
                            </EditableTooltip>
                        </Col>
                    </Row>
              <Row gutter={24}>
                <Col span={24} >
                    <FormItem label={t("Code")}>
                      {this.props.getFieldDecorator(nameof<NewEmployeeItem>('code'), {
                        initialValue: item.code,
                        rules: [],
                      })(
                        <Input placeholder={t('Code')} type="text" />
                      )}
                    </FormItem>
                </Col>
              </Row>
              <Row gutter={24}>
                <Col span={24} >
                  <EditableTooltip name="new-employee-send-invitation-email" noIcon>
                    <FormItem>
                      {this.props.getFieldDecorator(nameof<NewEmployeeItem>('notifyByEmail'), {
                        rules: [], initialValue: true, valuePropName: 'checked'
                      })(
                        <Checkbox><span>{t("Send invitation by email")}</span><Icon type="info-circle" style={{ fontSize: '12px', color: 'grey', marginRight: 3, marginLeft: 3 }} /></Checkbox>

                      )}
                    </FormItem>
                  </EditableTooltip>
                </Col>
              </Row>
            </Col>
            <Col span={12}>
              <Row gutter={24}>
                <Col span={24} >
                    <FormItem label={t("Family Name")}>
                      {this.props.getFieldDecorator(nameof<NewEmployeeItem>('lastName'), {
                        initialValue: item.lastName,
                        rules: [],
                      })(
                        <Input placeholder={t('Family Name')} type="text" />
                      )}
                    </FormItem>
                </Col>
              </Row>
              <EditableTooltip name="new-employee-manager" noIcon offset={8}>
                    <FormItem label={(
                        <LabelIcon>
                            { t("Line manager")}
                            </LabelIcon>
                    )}>
                        {this.props.getFieldDecorator(nameof<NewEmployeeItem>('managerId'), {
                            initialValue: item.managerId,
                            rules: [],
                        })(
                            <EmployeeEditor placeholder={t("Name")} companyId={this.props.companyId} nullable disabled={!userHasRole(this.props.userProfile, ["Manager", "Administrator", "ClientAdmin", "FIConsultant"])} />
                        )}
                    </FormItem></EditableTooltip>
                    <Row gutter={24} >   
                        <Col span={24} >
                                <FormItem label={ t("Language")}>
                                    {this.props.getFieldDecorator(nameof<NewEmployeeItem>('language'), {
                                        rules: [], initialValue: "en",
                                    })(
                                        <Select style={{ width: "100" }} >
                                            <Option value={"en"} key={"en"}> {t("English")} </Option>
                                            <Option value={"fr"} key={"fr"}> {t("French")} </Option>
                                            <Option value={"es"} key={"sp"}> {t("Spanish")} </Option>
                                            <Option value={"pt"} key={"pt"}> {t("Portuguese")} </Option>
                                            <Option value={"it"} key={"it"}> {t("Italian")} </Option>
                                        </Select>
                                    )}
                                </FormItem>
                        </Col>
              </Row>              
                </Col>
            </Row>
            <Divider />
            <Row gutter={24} align='middle' justify='center' >
                <Col span={8}>
                    <h5 style={{ fontWeight: 'bold', marginTop: '7px' }}>{t("Work regime")}</h5>
                </Col>
            </Row>

            <Row gutter={ 24} >
                <Col span={24}>
                    <FormItem label={<EditableTooltip name="employee-form-working-regime">{t("Apply the following restriction plan")}</EditableTooltip>} >
                        <Row  >
                            <Col span={12} style={{ marginRight: '-14px' }}>

                                {this.props.getFieldDecorator(nameof<NewEmployeeItem>('restrictionPlanId'), {
                                    initialValue: item.restrictionPlanId,
                                    rules: [],
                                })(
                                    <RestrictionPlanEditor
                                        placeholder={t("No plan selected")}
                                        companyId={this.props.companyId}
                                        disabled={!userHasRole(this.props.userProfile, ["Manager", "Administrator", "ClientAdmin", "FIConsultant"])}
                                        emptySign={t('There are no work regimes for this company yet and therefore the range to allocate hours is set between 0h and 24h')}
                                    />
                                )}
                            
                            </Col>
                            <Col span={4}>
                                <Button style={{ marginTop: '4px', marginRight:'20px' }} icon="plus" onClick={this.props.openRestrictionPlanAddModal} />
                            </Col >
                        </Row>

                        </FormItem>
                    
                </Col>
                
                

            </Row>
            <Divider />

            <Row gutter={24}>
                <h5 style={{ fontWeight: 'bold', marginTop: '7px' }}>{t("Notification options")}</h5>
            </Row>

            <Row gutter={24}>

               
                <Col span={24}>
                    {
                        !this.state.selectedEmployeeReminder &&
                        <Row gutter={24} type={'flex'} align='middle'>
                            <Col span={14}>
                                <EditableTooltip name="new-employee-send-weekly-reminder" noIcon>
                                    <FormItem>
                                        {this.props.getFieldDecorator(nameof<NewEmployeeItem>('timesheetReminder'), {
                                            rules: [],  normalize: (value) => { return +value }
                                        })(
                                            <Checkbox checked={false} defaultChecked={false} onChange={this.employeeReminderOnchange}> <span>{t("Send reminders for timesheet entry")}</span><Icon type="info-circle" style={{ fontSize: '12px', color: 'grey', marginRight: 3, marginLeft: 3 }} /></Checkbox>
                                        )}
                                    </FormItem>
                                </EditableTooltip>
                            </Col>
                            <Col span={10}>
                                <Select  style={{ width: "100" }} disabled>
                                    <Option value={1}> {t("Weekly")} </Option>
                                    <Option value={2}> {t("Fortnightly")} </Option>
                                    <Option value={3}> {t("Monthly")} </Option>
                                </Select>
                            </Col>
                        </Row>
                    }
                    {
                        this.state.selectedEmployeeReminder &&
                      
                        <Row gutter={24} type={'flex'} align='middle'>
                            <Col span={14}>
                                <EditableTooltip name="new-employee-send-weekly-reminder" noIcon>
                                    <Checkbox checked={true} defaultChecked={true} onChange={this.employeeReminderOnchange}><span>{t("Send reminders for timesheet entry")}</span><Icon type="info-circle" style={{ fontSize: '12px', color: 'grey', marginRight: 3, marginLeft: 3 }} /></Checkbox>
                                </EditableTooltip>
                            </Col>
                            <Col span={10}>
                                <FormItem>

                                    {this.props.getFieldDecorator(nameof<NewEmployeeItem>('timesheetReminder'), {
                                        rules: []
                                    })(
                                        <Select defaultValue={1} style={{ width: "100" }}>
                                            <Option value={1}> {t("Weekly")} </Option>
                                            <Option value={2}> {t("Fortnightly")} </Option>
                                            <Option value={3}> {t("Monthly")} </Option>
                                        </Select>
                                    )}

                                </FormItem>
                            </Col>
                        </Row>
                    }
                    
                    {
                        !this.state.selectedTeamReport &&
                        <Row gutter={24} type={'flex'} align='middle'>
                            <Col span={14}>
                                <EditableTooltip name="new-employee-send-team-report" noIcon>
                                    <FormItem>
                                        {this.props.getFieldDecorator(nameof<NewEmployeeItem>('teamReport'), {
                                            rules: [], normalize: (value) => { return +value }
                                        })(
                                            <Checkbox checked={false}  defaultChecked={false} onChange={this.teamReportOnchange}><span>{t("Send team report")}</span><Icon type="info-circle" style={{ fontSize: '12px', color: 'grey', marginRight: 3, marginLeft: 3 }} /></Checkbox>
                                        )}
                                    </FormItem>
                                </EditableTooltip>
                            </Col>
                            <Col span={10}>
                                <Select  style={{ width: "100" }} disabled>
                                    <Option value={1}> {t("Monthly")} </Option>
                                    <Option value={2}> {t("Quickly")} </Option>
                                    <Option value={3}> {t("Quarterly")} </Option>
                                </Select>
                            </Col>
                        </Row>
                    }
                    {
                        this.state.selectedTeamReport &&
                        <Row gutter={24} type={'flex'} align='middle'>
                            <Col span={14}>
                                <EditableTooltip name="new-employee-send-team-report" noIcon>
                                    <Checkbox checked={true} defaultChecked={true} onChange={this.teamReportOnchange} ><span>{t("Send team report")}</span><Icon type="info-circle" style={{ fontSize: '12px', color: 'grey', marginRight: 3, marginLeft: 3 }} /></Checkbox>
                                </EditableTooltip>
                            </Col>
                            <Col span={10}>
                                <FormItem>

                                    {this.props.getFieldDecorator(nameof<NewEmployeeItem>('teamReport'), {
                                        rules: []
                                    })(
                                        <Select defaultValue={2} style={{ width: "100" }}>
                                            <Option value={2}> {t("Quickly")} </Option>
                                            <Option value={1}> {t("Monthly")} </Option>
                                            <Option value={3}> {t("Quarterly")} </Option>
                                        </Select>
                                    )}

                                </FormItem>
                            </Col>
                        </Row>
                    }

                    
                    <Row gutter={24}>
                        <Col span={24}>
                            <EditableTooltip name="new-employee-send-timesheet-status-notification-employee" noIcon>
                                <FormItem>
                                    {this.props.getFieldDecorator(nameof<NewEmployeeItem>('timesheetStatusNotificationEmployee'), {
                                        rules: [], initialValue: item.timesheetStatusNotificationEmployee, valuePropName: 'checked'
                                    })(
                                        <Checkbox><span>{t("Send an email when approving / rejecting timesheet")}</span><Icon type="info-circle" style={{ fontSize: '12px', color: 'grey', marginRight: 3, marginLeft: 3 }} /></Checkbox>
                                    )}
                                </FormItem>
                            </EditableTooltip>
                        </Col>
                        
                    </Row>
                    <Row gutter={24}>
                        
                        <Col span={24}>
                            <EditableTooltip name="new-employee-send-timesheet-status-notification-manager" noIcon>
                                <FormItem>
                                    {this.props.getFieldDecorator(nameof<NewEmployeeItem>('timesheetStatusNotificationManager'), {
                                        rules: [], initialValue: item.timesheetStatusNotificationManager, valuePropName: 'checked'
                                    })(
                                        <Checkbox><span>{t("Send e-mail when timesheet has been published")}</span><Icon type="info-circle" style={{ fontSize: '12px', color: 'grey', marginRight: 3, marginLeft: 3 }} /></Checkbox>
                                    )}
                                </FormItem>
                            </EditableTooltip>
                        </Col>
                    </Row>
                    <Row gutter={24}>

                        <Col span={24}>
                            <EditableTooltip name="new-employee-send-deleted-project-notification" noIcon>
                                <FormItem>
                                    {this.props.getFieldDecorator(nameof<NewEmployeeItem>('deletedProjectNotification'), {
                                        rules: [], initialValue: true, valuePropName: 'checked'
                                    })(
                                        <Checkbox><span>{t("Send e-mail when a project has been deleted")}</span><Icon type="info-circle" style={{ fontSize: '12px', color: 'grey', marginRight: 3, marginLeft: 3 }} /></Checkbox>
                                    )}
                                </FormItem>
                            </EditableTooltip>
                        </Col>
                    </Row>
                </Col>
            </Row>
            <Divider />

            <Row gutter={24}>
                <Col span={8}>
                    <h5 style={{ fontWeight: 'bold', marginTop: '7px' }}>{t("Timesheet option")}</h5>
                </Col>
            </Row>
            <Row gutter={24}>
                
                <Col span={24}>
                    <EditableTooltip name="new-employee-clone-previous-timesheet" noIcon>
                        <FormItem>
                            {this.props.getFieldDecorator(nameof<NewEmployeeItem>('cloneTimesheet'), {
                                rules: [], initialValue: true, valuePropName: 'checked'
                            })(
                                <Checkbox><span>{t("Clone previous timesheet tasks when generating new timesheet")}</span><Icon type="info-circle" style={{ fontSize: '12px', color: 'grey', marginRight: 3, marginLeft: 3 }} /></Checkbox>
                            )}
                        </FormItem>
                    </EditableTooltip>
                </Col>
            </Row>
            < Divider />
            {
                (this.props.allowCir || this.props.allowCii) &&
                <div>
                    <Row gutter={24}>
                        <Col span={8}>
                            <h5 style={{ fontWeight: 'bold', marginTop: '7px' }}>{(this.props.allowCir && this.props.allowCii) ? t("Eligibility for CIR / CII") : this.props.allowCir ? t("Eligibility for CIR") : t("Eligibility for CII") }</h5>
                        </Col>
                    </Row> 
                    <Row gutter={24}>
               
                        
                        {
                            this.props.allowCir &&
                            <Col span={12}>
                                <EditableTooltip name="new-employee-CIR-eligible" noIcon>
                                    <FormItem>
                                        {this.props.getFieldDecorator(nameof<NewEmployeeItem>('cirEligible'), {
                                            rules: [], initialValue: this.props.allowCir, valuePropName: 'checked'
                                        })(
                                            <Checkbox disabled={!this.props.allowCir}><span>{t("Profile is eligible to CIR")}</span><Icon type="info-circle" style={{ fontSize: '12px', color: 'grey', marginRight: 3, marginLeft: 3 }} /></Checkbox>
                                        )}
                                    </FormItem>
                                </EditableTooltip>
                            </Col>
                        }
                        {
                            this.props.allowCii &&
                            <Col span={12}>
                                <EditableTooltip name="new-employee-CII-eligible" noIcon>
                                    <FormItem>
                                        {this.props.getFieldDecorator(nameof<NewEmployeeItem>('ciiEligible'), {
                                            rules: [], initialValue: this.props.allowCii, valuePropName: 'checked'
                                        })(
                                            <Checkbox disabled={!this.props.allowCii}><span>{t("Profile is eligible to CII")}</span><Icon type="info-circle" style={{ fontSize: '12px', color: 'grey', marginRight: 3, marginLeft: 3 }} /></Checkbox>
                                        )}
                                    </FormItem>
                                </EditableTooltip>
                            </Col>
                        }
                    </Row>
            
                    <Divider />
                </div>
            }
            <Row gutter={24}>
                <Col span={8}>
                    <h5 style={{ fontWeight: 'bold' }}>{t("Estimated hourly cost (in ") + this.props.currency + ")"}</h5>
                </Col>
            </Row>
            <Row gutter={24}>
               
                <Col span={24}>
                    <Row>
                        {t("Estimated hourly cost (in ") + this.props.currency + ")"}
                    </Row>
                    <Row>
                        <EditableTooltip name="new-employee-estimated-hourly-cost" noIcon>
                            <FormItem>
                                
                                {this.props.getFieldDecorator(nameof<NewEmployeeItem>('estimatedHourlyCost'), {
                                    rules: [], initialValue: 0, valuePropName: 'value'
                                })(
                                    <InputNumber
                                        style={{ width: '234.17px' }}
                                        min={0} step={0.25}
                                        defaultValue={0}
                                        formatter={value => value ? `${value}` + this.props.currency : "0.00" + this.props.currency}
                                        parser={value => value ? value.replace(this.props.currency, '') : ''}
                                        onFocus={this.handleFocus}
                                    >
                                        {t("estimated hourly cost")}
                                    </InputNumber>

                                )}
                            </FormItem>
                        </EditableTooltip>
                    </Row>
                </Col>
            </Row>
            

        </Form>
    }
}

@connect(["newEmployee", NewEmployeeStore])
class NewEmployeeView extends React.Component<NewEmployeeViewProps & WithTranslation & FormComponentProps, NewEmployeeViewState> {
    private get newEmployeeStore() {
        return (this.props as any).newEmployee as NewEmployeeStore;
    }

    constructor(props: NewEmployeeViewProps & WithTranslation & FormComponentProps) {
        super(props);
        this.state = {
            restrictionPlanId: null,
            showRestrictionPlanCreationModal: false,
            showSetManagerModal: false,
        }
        this.newEmployeeStore.createNew({} as any);
        this.newEmployeeStore.changeUrl(this.props.companyId);
    }

    componentWillReceiveProps(nextProps: NewEmployeeViewProps) {
        if (this.newEmployeeStore.state.result && this.newEmployeeStore.state.result.isSuccess)
            nextProps.onClose((this.newEmployeeStore.state.result as any).aggregateRootId, this.newEmployeeStore.state.item)
    }

    @autobind
    private countDownNotification(_notification: any, message: string, description: string, key: string) {
        let secondsToGo = 4;
        _notification({
            key: key,
            message: message + `(${secondsToGo}).`,
            description: description
        });
        const timer = setInterval(() => {
            secondsToGo -= 1;
            _notification({
                key: key,
                message: message + `(${secondsToGo}).`,
                description: description,
                onClose: () => clearInterval(timer),
            });
        }, 1000);
        setTimeout(() => {
            clearInterval(timer);
            notification.close(key);
        }, secondsToGo * 1000);
    }

    @autobind
    private async onCreateNewItem(checkManagerRole: boolean) {
        var self = this;
        const { t } = this.props as any;
        if (checkManagerRole) {
            var manager = this.props.form.getFieldValue('managerId') + ''
            if (manager === "undefined") {
                this.setState({ showSetManagerModal: true })
                return
            }
            var isManager = await self.newEmployeeStore.getRoles(manager)
            if (!isManager) {
                this.setState({ showSetManagerModal: true })
                return
            }
        }
       
        return new Promise((resolve, reject) => {
            self.props.form.validateFields(event => {
                var values = self.props.form.getFieldsValue();
                if (!event) {
                    const employeeValues = { ...values, companyId: this.props.companyId } as Partial<NewEmployeeItem>;
                    
                    self.newEmployeeStore.change(employeeValues);
                    self.newEmployeeStore.submit().then(result => {
                        if (result.isSuccess) {
                            resolve();
                            this.props.onClose('employee')
                            this.countDownNotification(notification.success, t('Success'), t('Employee added successfully'), 'success')
                            const modal = Modal.info({
                                title: t("Information"),
                                content: t("The generation of the weekly sheet of the registered user will not be effective until the next day and until then it will not appear among the sheets of the subordinate team"),
                                onOk() { }
                            });
                        } else {
                            reject();
                            this.countDownNotification(notification.success, t('Error'), t('There was an error'), 'fail')
                        }
                    });
                }
            });
        })
    }

    @autobind
    private onCancelNewItem() {
        this.newEmployeeStore.clear();
        this.props.onClose(undefined);
    }

    @autobind
    private onCreateRestrictionPlanOpen() {
        this.setState({ showRestrictionPlanCreationModal : true })
    }

    @autobind
    private onRestrictionPlanCreationModalClose(id: string | undefined) {
        this.setState({ showRestrictionPlanCreationModal: false })
        if (this.newEmployeeStore.state.item && id) {
            var item = this.newEmployeeStore.state.item
            item.restrictionPlanId = id
            this.newEmployeeStore.change(item)
        }   
    }

    public render() {
        const { getFieldDecorator, setFieldsValue } = this.props.form;
        const { t } = this.props;
        return (
            <Modal
                maskClosable={false}
                visible
                onCancel={this.onCancelNewItem}
                onOk={() => { this.onCreateNewItem(true) }}
                closable={false}
                width='800px'
                okText={t("OK")}
                cancelText={t("Cancel")}
                title={t("New employee")}>
                {this.newEmployeeStore.state.result && !this.newEmployeeStore.state.result.isSuccess &&
                    <Alert type='error'
                    message={t("An error has occurred")}
                        description={t(formatMessage(this.newEmployeeStore.state.result))}
                    />
                }
                <Spin spinning={this.newEmployeeStore.state.isBusy}>
                    <EmployeeFormBody
                        userProfile={this.props.userProfile}
                        setFieldsValue={this.props.form.setFieldsValue}
                        companyId={this.props.companyId}
                        i18n={this.props.i18n} t={this.props.t} tReady={this.props.tReady}
                        item={this.newEmployeeStore.state.item}
                        getFieldDecorator={getFieldDecorator}
                        onSave={() => this.onCreateNewItem(true)}
                        openRestrictionPlanAddModal={this.onCreateRestrictionPlanOpen}
                        allowCir={this.props.allowCir}
                        allowCii={this.props.allowCii}
                        currency={this.props.currency}
                    />
                </Spin>
                { this.state.showRestrictionPlanCreationModal && (
                    <NewRestrictionPlanView
                        userProfile={this.props.userProfile}
                        companyId={this.props.companyId}
                        onClose={this.onRestrictionPlanCreationModalClose}
                    />
                )}
                    <Modal
                        visible={this.state.showSetManagerModal}
                        closable={false}
                    onOk={() => {
                        this.setState({ showSetManagerModal: false })
                        this.onCreateNewItem(false)
                    }}
                        onCancel={() => this.setState({ showSetManagerModal: false })}
                        okText={t("Ok")}
                        cancelText={t("Cancel")}
                    title={t('Confirmation required')}>
                    <p>{this.props.form.getFieldValue('managerId') === undefined ? t("Are you sure you want to assign the role \"Manager\" to the new employee?") : t("The line manager selected does not have the role \"Manager\". Are you sure you want to assign it?")}</p>
                    </Modal>
            </Modal>
        );
    }
}

// Wire up the React component to the Redux store
export default withTranslation()(withIdentity(Form.create({})(NewEmployeeView as any) as any)) as any as React.ComponentClass<NewEmployeeViewProps>;